import { register } from "@shopify/theme-sections";
import Swiper from "swiper/bundle";

register("image-gallery", {
  initSlider() {
    const dataEl = this.container.querySelector("[data-section-data]");
    const settings = JSON.parse(dataEl.innerHTML);
    const carousel = this.container.querySelector("[data-image-gallery]");
    if (!carousel) return;
    const swiper = new Swiper(carousel, {
      slidesPerView: "auto",
      centeredSlides: true,
      loop: settings.allowLoop,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: carousel.querySelector(".swiper-button-next"),
        prevEl: carousel.querySelector(".swiper-button-prev"),
      },
    });
  },

  onLoad: function (e) {
    this.initSlider();
  },
});
